
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Medication = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M18.6,14.2a4.4,4.4,0,1,0,4.5,4.4A4.4,4.4,0,0,0,18.6,14.2Zm0,1.5a3,3,0,0,1,2.9,2.2H15.8A2.9,2.9,0,0,1,18.6,15.7Zm0,5.8a2.9,2.9,0,0,1-2.8-2.1h5.7A3,3,0,0,1,18.6,21.5Z"></path>
            <path d="M18.3,3.3A4.7,4.7,0,0,0,15,1.9a5.1,5.1,0,0,0-3.6,1.5l-8,8a4.9,4.9,0,0,0-.1,6.9,4.6,4.6,0,0,0,3.3,1.3,5.1,5.1,0,0,0,3.6-1.5l7.9-7.9A4.9,4.9,0,0,0,18.3,3.3ZM9.1,17.1a3.3,3.3,0,0,1-2.5,1,3.1,3.1,0,0,1-2.2-.9,2.8,2.8,0,0,1-.9-2.3,3.1,3.1,0,0,1,1-2.4L8,9l4.6,4.6Zm8-8-3.5,3.5L9,7.9l3.5-3.4A3.3,3.3,0,0,1,15,3.4a3.2,3.2,0,0,1,2.2,1A3.3,3.3,0,0,1,17.1,9.1Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Medication.defaultProps = {
  title: 'Medication',
};

export default Medication;
